import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

interface ReorderDataHooks {
  dataHookFrom: string;
  dataHookTo: string;
}

interface NestableItemDetails {
  dataHook: string;
  depthLevel: number;
  threshold?: number;
}

export interface NestableListBaseUniDriver extends BaseUniDriver {
  reorder: (dataHooks: ReorderDataHooks) => Promise<void>;
  changeItemDepth: (itemDetails: NestableItemDetails) => Promise<void>;
  getItemPosition: (itemDetails: { dataHook: string }) => Promise<number>;
  getItemDepth: (itemDetails: { dataHook: string }) => Promise<number>;
}
